import React from "react";
import { Divider, Icon } from "semantic-ui-react";
import StrategyPropertyHeader from "./StrategyPropertyHeader";

// One property's full Strategy dashboard: a single bordered container
// holding a compact property-information header, a divider, then a grid of
// available Strategy Cards. Used for the Buyer page's current (and any
// expanded previous) property, and for the Seller page's single property -
// the one shared container that makes both pages feel like the same
// product. The border is the ONLY thing that distinguishes a Buyer's
// current property (blue, per spec) from every other property dashboard
// (neutral) - everything else about the container is identical.
//
// The grid intentionally uses `repeat(auto-fit, minmax(...))` rather than a
// hardcoded column count: since a Buyer property always has exactly 3 cards
// and a Seller property exactly 2, auto-fit already yields "3 columns on a
// wide desktop" / "2 columns on a wide desktop" on its own (there's never a
// 4th/3rd card to fill a 4th/3rd column), while naturally reducing to fewer
// columns - and finally one column - as the viewport narrows, with no
// separate breakpoint logic to keep in sync with the card count.
export default function StrategyPropertyDashboard({ propertyHeaderProps, children, minCardWidth = 240, isCurrent, showUnlockedBanner, style }) {
  return (
    <div
      style={{
        background: "#ffffff",
        border: `1px solid ${isCurrent ? "#2185d0" : "#e0e1e2"}`,
        borderWidth: isCurrent ? "2px" : "1px",
        borderRadius: "10px",
        padding: "18px",
        ...style,
      }}
    >
      <StrategyPropertyHeader {...propertyHeaderProps} isCurrent={isCurrent} />
      <Divider style={{ margin: "18px 0" }} />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fit, minmax(${minCardWidth}px, 1fr))`,
          gap: "20px",
          alignItems: "stretch",
        }}
      >
        {children}
      </div>

      {/* Shown once, for the whole property, rather than repeated per card -
          a property that's already unlocked should never look like another
          card's "Generate" might ask for a second credit. */}
      {showUnlockedBanner && (
        <div
          style={{
            marginTop: "18px", padding: "12px 14px", borderRadius: "8px",
            background: "#eaf4fc", border: "1px solid #d6e9f8",
            display: "flex", gap: "10px", alignItems: "flex-start",
          }}
        >
          <Icon name="info circle" color="blue" style={{ marginTop: "2px" }} aria-hidden="true" />
          <div>
            <div style={{ fontWeight: 700, fontSize: "0.92em" }}>All Strategies Included</div>
            <div className="text-grey" style={{ fontSize: "0.85em", marginTop: "2px" }}>
              One Strategy Credit unlocks all available strategies for this property, including regeneration. Edit
              the property details and regenerate as needed.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
